






















import Vue from "vue";
import Lightbox from "@/components/Lightbox.vue";

export default Vue.extend({
    components: {
        Lightbox
    }
});
